"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TrashcanSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var TrashcanSVG = function TrashcanSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M27,6H21.618L20.171,3.106A1.987,1.987,0,0,0,18.382,2H13.618a1.988,1.988,0,0,0-1.789,1.105L10.382,6H5A1,1,0,0,0,5,8H6V28a2.006,2.006,0,0,0,2,2H24a2.006,2.006,0,0,0,2-2V8h1a1,1,0,0,0,0-2ZM14,25a1,1,0,0,1-2,0V11a1,1,0,0,1,2,0Zm6,0a1,1,0,0,1-2,0V11a1,1,0,0,1,2,0ZM13.618,4h4.764l1,2H12.618Z"
  }));
};
exports.TrashcanSVG = TrashcanSVG;
TrashcanSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(TrashcanSVG);
exports.default = _default;